// Structuur & logica per vraag-id (niet bewerkbaar in theme editor).
// Content (labels, hints, opties) komt uit section blocks → zie quiz-config.js merge.

const FLOW_FULL = "full";
const FLOW_LIGHT = "light";
const FLOW_ABONNEMENT = "abonnement";
const ALL_FLOWS = [FLOW_FULL, FLOW_LIGHT, FLOW_ABONNEMENT];

// Vertaalde UI-tekst uit locales (zie quiz-engine.liquid → window.WolforkQuizI18n), NL als fallback.
function quizText(key, fallback) {
  return (window.WolforkQuizI18n && window.WolforkQuizI18n[key]) || fallback;
}

// Puppy's en drachtige/zogende honden hebben maar één smaakvariant:
// de vragen "kieskeurige eter" en "allergie" zijn dan niet relevant.
function hasSingleFlavorVariant(s) {
  if (s.pregnant === true || s.nursing === true) return true;
  const adh = window.WolforkQuizAdh;
  if (!adh) return false;
  const stage = adh.resolveLifestage(s);
  return stage === "puppy" || stage === "mother";
}

// QR/PDP-flow: de receptuur is vooraf gekozen. Drachtig/zogend is dan
// alleen relevant bij de Drachtig & Zogend-receptuur; elke andere keuze
// slaat die vragen over. Zonder receptuurkeuze (volledige quiz) beslissen
// gender en sterilisatie zoals altijd.
function pregnancyQuestionsApply(s) {
  const r = String(s.recipe || "").toLowerCase();
  if (!r) return true;
  return r.includes("drachtig") || r.includes("zogend");
}

window.WolforkQuizLogic = {
  defaultOrder: [
    "dog_name",
    "recipe",
    "gender",
    "sterilized",
    "pregnant",
    "pregnancy_weeks",
    "nursing",
    "nursing_weeks",
    "puppies_count",
    "age_value",
    "breed",
    "weight_kg",
    "expected_weight_kg",
    "has_conditions",
    "body_shape",
    "activity_level",
    "current_food",
    "raw_percentage",
    "eater_type",
    "has_allergies",
    "daily_treats",
    "email",
  ],

  defaultContent: {
    dog_name: {
      section_nl: "Profiel",
      label_nl: "Hoe heet je hond?",
      placeholder_nl: "Vul de naam van je hond in...",
    },
    recipe: {
      section_nl: "Voeding",
      label_nl: "Welke Wolfork receptuur heb je voor {dog_name}?",
    },
    gender: {
      section_nl: "Profiel",
      label_nl: "Is {dog_name} een reu of een teefje?",
      options: [
        { value: "reu", label_nl: "Reu" },
        { value: "teefje", label_nl: "Teefje" },
      ],
    },
    sterilized: {
      section_nl: "Profiel",
      label_nl: "Is {dog_name} {sterilized_word}?",
      expert_tip_nl:
        "De hormoonbalans van gecastreerde honden verandert. Daardoor hebben ze minder calorieën per maaltijd nodig.<br><br>Geen zorgen, we houden hier rekening mee bij het voedingsadvies voor <strong>{dog_name}</strong>.",
    },
    pregnant: { section_nl: "Profiel", label_nl: "Is {dog_name} drachtig?" },
    pregnancy_weeks: { section_nl: "Profiel", label_nl: "Hoeveel weken is {dog_name} drachtig?" },
    nursing: { section_nl: "Profiel", label_nl: "Is {dog_name} zogend?" },
    nursing_weeks: { section_nl: "Profiel", label_nl: "Hoeveel weken is {dog_name} al zogend?" },
    puppies_count: { section_nl: "Profiel", label_nl: "Hoeveel puppies heeft {dog_name}?" },
    age_value: {
      section_nl: "Profiel",
      label_nl: "Hoe oud is {dog_name}? (ongeveer)",
      lead_nl: "",
    },
    breed: {
      section_nl: "Profiel",
      label_nl: "Wat is het ras van {dog_name}?",
      panel_label_nl: "Ras",
      placeholder_nl: "Zoek een ras... (bijv. Golden Retriever)",
      fallback_before_nl: "Weet je het niet? Selecteer ",
      fallback_link_nl: "Kruising",
      fallback_after_nl: " of de dichtstbijzijnde match.",
      expert_tip_nl: "",
    },
    weight_kg: { section_nl: "Profiel", label_nl: "Hoeveel weegt {dog_name} nu (ongeveer)?" },
    expected_weight_kg: {
      section_nl: "Profiel",
      label_nl: "Wat is het verwachte volwassen gewicht van {dog_name}?",
      hint_nl: "Bij twijfel: kijk naar het gewicht van ouders of vergelijkbare honden van hetzelfde ras.",
    },
    has_conditions: {
      section_nl: "Profiel",
      label_nl: "Heeft {dog_name} ziektes of aandoeningen?",
      expert_tip_nl:
        "",
    },
    body_shape: {
      section_nl: "Profiel",
      label_nl: "Hoe zou je het lichaam van {dog_name} omschrijven?",
      options: [
        {
          value: "underweight",
          label_nl: "Mager",
          desc_nl: "Ribben, ruggengraat en bekken zijn duidelijk zichtbaar",
          image: "quiz-body-lean.png",
        },
        {
          value: "ideal",
          label_nl: "Ideaal",
          desc_nl: "Ribben en ruggengraat zijn niet zichtbaar, maar wel voelbaar door een dun vetlaagje",
          image: "quiz-body-ideal.png",
        },
        {
          value: "overweight",
          label_nl: "Stevig",
          desc_nl: "Ribben, ruggengraat en bekken voel je door een laag vet heen",
          image: "quiz-body-chubby.png",
        },
        {
          value: "obese",
          label_nl: "Overgewicht",
          desc_nl: "Ribben en bekken zijn vrijwel niet meer voelbaar",
          image: "quiz-body-obese.png",
        },
      ],
    },
    activity_level: {
      section_nl: "Profiel",
      label_nl: "Hoeveel beweging krijgt {dog_name} dagelijks?",
      options: [
        {
          value: "low",
          label_nl: "1 uur of minder",
          desc_nl: "Korte wandelingen en licht spelen door de dag",
          image: "quiz-activity-low.png",
        },
        {
          value: "medium",
          label_nl: "1-3 uur",
          desc_nl: "Regelmatige wandelingen en gemiddelde dagelijkse beweging",
          image: "quiz-activity-medium.png",
        },
        {
          value: "high",
          label_nl: "3+ uur",
          desc_nl: "Veel beweging en actieve speelsessies per dag",
          image: "quiz-activity-high.png",
        },
        {
          value: "very_high",
          label_nl: "Werkhond",
          desc_nl: "Hogere mate van dagelijkse fysieke activiteit en training",
          image: "quiz-activity-working.png",
        },
      ],
    },
    current_food: {
      section_nl: "Profiel",
      label_nl: "Welk voer geef je {dog_name} momenteel?",
      options: [
        { value: "kibble", label_nl: "Brokken", image: "quiz-food-kibble.png" },
        { value: "wet", label_nl: "Natvoer", image: "quiz-food-wet.png" },
        { value: "raw", label_nl: "Rauw", image: "quiz-food-raw.png" },
        { value: "cooked", label_nl: "Gekookt", image: "quiz-food-cooked.png" },
      ],
    },
    raw_percentage: {
      section_nl: "Voeding",
      label_nl: "Hoeveel % van de dagelijkse voeding ben je van plan om Wolfork te geven?",
      hint_nl:
        "Geef aan welk deel van de dagelijkse portie uit Wolfork bestaat. De rest vul je zelf aan met ander voer.",
      options: [
        { value: 25, label_nl: "25%" },
        { value: 33, label_nl: "33%" },
        { value: 50, label_nl: "50%" },
        { value: 100, label_nl: "100%" },
      ],
    },
    eater_type: {
      section_nl: "Profiel",
      label_nl: "Wat voor eter is {dog_name}?",
      options: [
        { value: "picky", label_nl: "Kieskeurige eter" },
        { value: "everything", label_nl: "Echte alleseter" },
      ],
    },
    has_allergies: {
      section_nl: "Advies",
      label_nl: "Heeft {dog_name} een gevoelige maag, of is {dog_name} allergisch voor kip of rund?",
    },
    daily_treats: {
      section_nl: "Advies",
      label_nl: "Hoeveel snoepjes of beloningen krijgt {dog_name} dagelijks?",
      options: [
        {
          value: "none",
          label_nl: "Niets",
          desc_nl: "Krijgt zelden of nooit snoepjes of snacks",
          image: "quiz-treat-none.png",
        },
        {
          value: "few",
          label_nl: "Een paar",
          desc_nl: "Krijgt af en toe een klein aantal snoepjes",
          image: "quiz-treat-few.png",
        },
        {
          value: "more",
          label_nl: "Iets meer",
          desc_nl: "Krijgt regelmatig snoepjes naast de maaltijden",
          image: "quiz-treat-more.png",
        },
        {
          value: "lot",
          label_nl: "Veel",
          desc_nl: "Krijgt vaak snoepjes door de dag heen",
          image: "quiz-treat-lot.png",
        },
      ],
    },
    email: {
      section_nl: "Afronden",
      label_nl: "Waar mogen we het advies naartoe sturen?",
      hint_nl:
        "We sturen het persoonlijke voedingsadvies voor {dog_name} per e-mail en bewaren het in een gratis Wolfork-account.",
      placeholder_nl: "jouw@email.nl",
      consent_nl: quizText("consent_html", "Ja, ik wil af en toe tips en aanbiedingen van Wolfork ontvangen. Afmelden kan altijd."),
      info_nl:
        "We gebruiken je e-mailadres voor je voedingsadvies en je account. We gaan zorgvuldig met je gegevens om.",
      submit_label_nl: "Bekijk mijn advies",
    },
  },

  byId: {
    dog_name: {
      type: "text",
      flows: ALL_FLOWS,
      validation: (v) => (v?.trim().length ? null : quizText("error_name", "Vul een naam in")),
    },
    recipe: {
      type: "single-select",
      display: "recipe-cards",
      flows: [FLOW_LIGHT],
      options_source: "recipe_products",
      validation: (v) => (v ? null : quizText("error_recipe", "Kies een receptuur")),
    },
    gender: {
      type: "single-select",
      display: "gender-cards",
      flows: ALL_FLOWS,
      validation: (v) => (v ? null : quizText("error_option", "Kies een optie")),
    },
    sterilized: {
      type: "yes-no",
      display: "photo-cards",
      flows: ALL_FLOWS,
      validation: (v) => (v === true || v === false ? null : quizText("error_option", "Kies een optie")),
    },
    pregnant: {
      type: "yes-no",
      flows: ALL_FLOWS,
      // Gesteriliseerde teef kan niet drachtig zijn; QR/PDP alleen bij Drachtig & Zogend-receptuur
      condition: (s) => s.gender === "teefje" && s.sterilized !== true && pregnancyQuestionsApply(s),
      validation: (v) => (v === true || v === false ? null : quizText("error_option", "Kies een optie")),
    },
    pregnancy_weeks: {
      type: "numeric",
      flows: ALL_FLOWS,
      min: 1,
      max: 9,
      decimals: 0,
      condition: (s) => s.pregnant === true,
      validation: (v) => (v >= 1 ? null : quizText("error_value", "Vul een waarde in")),
    },
    nursing: {
      type: "yes-no",
      flows: ALL_FLOWS,
      // Alleen relevant als de hond nu niet drachtig is: zogen volgt op de bevalling.
      // Drachtig=ja slaat dit over; de formule rekent lactatie sowieso boven dracht.
      condition: (s) => s.gender === "teefje" && s.sterilized !== true && s.pregnant === false && pregnancyQuestionsApply(s),
      validation: (v) => (v === true || v === false ? null : quizText("error_option", "Kies een optie")),
    },
    nursing_weeks: {
      type: "numeric",
      flows: ALL_FLOWS,
      min: 1,
      max: 12,
      decimals: 0,
      condition: (s) => s.nursing === true,
      validation: (v) => (v >= 1 ? null : quizText("error_value", "Vul een waarde in")),
    },
    puppies_count: {
      type: "numeric",
      flows: ALL_FLOWS,
      min: 1,
      max: 15,
      decimals: 0,
      condition: (s) => s.nursing === true,
      validation: (v) => (v >= 1 ? null : quizText("error_value", "Vul een waarde in")),
    },
    age_value: {
      type: "numeric",
      display: "age-split",
      flows: ALL_FLOWS,
      min: 1,
      max: 240,
      decimals: 0,
      validation: (v) => (v >= 1 ? null : quizText("error_age", "Vul een leeftijd in")),
    },
    breed: {
      type: "autocomplete",
      display: "breed-search",
      flows: ALL_FLOWS,
      options_source: "dog_breed_metaobjects",
      allow_custom: quizText("mixed_breed", "Kruising"),
      validation: (v) => (v ? null : quizText("error_breed", "Kies een ras uit de lijst")),
    },
    weight_kg: {
      type: "numeric",
      display: "weight-stepper",
      flows: ALL_FLOWS,
      unit: "kg",
      min: 0.5,
      max: 100,
      decimals: 1,
      expert_tip_dynamic: "breed_weight",
      validation: (v) => (v >= 0.5 ? null : quizText("error_weight", "Vul een gewicht in")),
    },
    expected_weight_kg: {
      type: "numeric",
      display: "weight-stepper",
      flows: ALL_FLOWS,
      unit: "kg",
      min: 0.5,
      max: 100,
      decimals: 1,
      condition: (s) => {
        const months = s.age_unit === "jaren" ? s.age_value * 12 : s.age_value;
        return months < 24;
      },
      // Bij puppy's hoort de gemiddeld-volwassen-gewicht-tip hier (verwacht gewicht),
      // niet bij het huidige gewicht. Zie weight_kg + isExpertTipVisible() in quiz-engine.js.
      expert_tip_dynamic: "breed_weight",
      prefill: (s) => s.breed_baseline_weight_kg ?? null,
      validation: (v) => (v >= 0.5 ? null : quizText("error_weight", "Vul een gewicht in")),
    },
    has_conditions: {
      type: "yes-no",
      display: "condition-cards",
      flows: [FLOW_FULL],
      validation: (v) => (v === true || v === false ? null : quizText("error_option", "Kies een optie")),
    },
    body_shape: {
      type: "image-select",
      display: "body-cards",
      flows: ALL_FLOWS,
      validation: (v) => (v ? null : quizText("error_option", "Kies een optie")),
    },
    activity_level: {
      type: "single-select",
      flows: ALL_FLOWS,
      validation: (v) => (v ? null : quizText("error_option", "Kies een optie")),
    },
    current_food: {
      type: "multi-select",
      flows: [FLOW_FULL],
      validation: (v) => (Array.isArray(v) && v.length > 0 ? null : quizText("error_options", "Kies minimaal één optie")),
    },
    raw_percentage: {
      type: "single-select",
      flows: [FLOW_FULL],
      validation: (v) => (v != null && v !== "" ? null : quizText("error_option", "Kies een optie")),
    },
    eater_type: {
      type: "single-select",
      flows: [FLOW_FULL],
      condition: (s) => !hasSingleFlavorVariant(s),
      validation: (v) => (v ? null : quizText("error_option", "Kies een optie")),
    },
    has_allergies: {
      type: "yes-no",
      display: "allergy-cards",
      flows: [FLOW_FULL],
      condition: (s) => !hasSingleFlavorVariant(s),
      validation: (v) => (v === true || v === false ? null : quizText("error_option", "Kies een optie")),
    },
    daily_treats: {
      type: "image-select",
      display: "body-cards",
      flows: [FLOW_FULL],
      validation: (v) => (v ? null : quizText("error_option", "Kies een optie")),
    },
    email: {
      type: "text",
      display: "email-finish",
      flows: ALL_FLOWS,
      input_type: "email",
      condition: (s) => !s.logged_in_customer_id,
      validation: (v) =>
        /\S+@\S+\.\S+/.test(String(v || "").trim()) ? null : quizText("error_email", "Vul een geldig e-mailadres in"),
    },
  },
};
